/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyAsanaIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-asana" */ './utils').then((m) => m.AsanaIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/asana/icon' },
);

const LazyAsanaSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-asana-search-result" */ './utils').then(
			(m) => m.AsanaSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/asana/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const AsanaIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyAsanaIconComponent />
	</Suspense>
);

export const AsanaSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyAsanaSearchResultIconComponent />
	</Suspense>
);
